import { createContext, FC, useContext, useState } from 'react';

import { IOptionType } from 'interfaces/forms';

import { IActiveTabContextProviderProps, ICreateContextType } from './types';

const TabChangeContext = createContext({} as ICreateContextType);

export const useTabChangeContext = () => {
  const value = useContext(TabChangeContext);
  if (Object.keys(value).length === 0) throw new Error('Use useTabChangeContext hook within ActiveTabContextProvider');
  return value;
};

export const ActiveTabContextProvider: FC<IActiveTabContextProviderProps> = ({ children, initialValue }) => {
  const [activeTab, setActiveTab] = useState<IOptionType>(initialValue);

  const handleTabChange = (value: IOptionType[]) => {
    setActiveTab(value[0]);
  };
  return (
    <TabChangeContext.Provider value={{ activeTab, onTabChange: handleTabChange }}>
      {children}
    </TabChangeContext.Provider>
  );
};
